
/*
 *   File : fund-redeem.js
 *   Author URI : https://evoqins.com
 *   Description : create a redeem request from an invested MF
 *   Integrations : null
 *   Version : v1.1
 */

import { Fragment, useEffect, useRef, useState, useContext } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Modal } from "bootstrap";

import Icon from "../Icon/icon";
import { CustomRedeemTextInput, OTPInput, CustomRedeemInput } from "../Form-elements";
import { useClickOutside, _getDayOfMonth } from "../../Helper";
import { GradientButton } from "../CTA";
import ActivateDDPIModal from "./activate-ddpi-modal";
import APIService from "../../Service/api-service";
import { _consent2FA } from "../../Helper/api";
import { DarkModeContext } from "../../Context/dark-mode-context";

import style from "../../Styles/Component/fund-redeem.module.scss"
import Colors from '../../Styles/color.module.scss';

const FundRedeemModal = (props) => {
    const { darkMode } = useContext(DarkModeContext);
    const navigate = useNavigate();
    const PROFILE_DATA = useSelector(state => state.generalData.PROFILE_DATA);

    const dropDownRef = useRef();
    const amountRef = useRef(null);

    const { date } = _getDayOfMonth();

    const [selectedFolio, setSelectedFolio] = useState([]);

    console.log('selectedFolio', selectedFolio);

    const [folioError, setFolioError] = useState("");
    const [availableUnits, setAvailableUnits] = useState(0);
    const [showFolioDropDown, setShowFolioDropDown] = useState(false);
    const [displayFolioText, setDisplayFolioText] = useState("");
    const [folioData, setFolioData] = useState([]);
    const [withdrawUnits, setWithDrawUnits] = useState("")
    console.log('withdrawUnits', withdrawUnits);

    const [withdrawUnitsError, setWithdrawUnitsError] = useState("");
    const [withdrawAll, setWithdrawAll] = useState(false);
    const [tax, setTax] = useState(0);
    const [showBank, setShowBank] = useState(false);
    const [selectedBank, setSelectedBank] = useState({});
    const [proceed, setProceed] = useState(false);
    const [pinString, setPinString] = useState("");
    const [pinError, setPinError] = useState("");
    const [apiLoader, setApiLoader] = useState(false);
    const [withdrawAmount, setWithdrawAmount] = useState("");
    const [withdrawAmountError, setWithdrawAmountError] = useState('');
    const [mfData, setMfData] = useState(props.data);
    console.log('mfData', mfData);

    const [seconds, setSeconds] = useState(30);
    const [longTermCapitalGain, setLongTermCapitalGain] = useState("");
    const [shortTermCapitalGain, setShortTermCapitalGain] = useState("");

    /** Redemption mode per depository spec: P = physical (folio), D = demat (DTR / pay-in path). */
    const [redeemMode, setRedeemMode] = useState("P");
    const [activateDDPIModal, setActivateDDPIModal] = useState(false);


    // Modal close listener
    useEffect(() => {
        var my_modal = document.getElementById("fund-redeem");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.close();
        });
    }, []);

    // useEffect(() => {
    //     var my_modal = document.getElementById("activate-ddpi-modal");
    //     my_modal.addEventListener("hidden.bs.modal", () => {
    //         props.close();
    //     });
    // }, []);


    useEffect(() => {
        if (activateDDPIModal !== true) return;
        const el = document.getElementById("activate-ddpi-modal");
        if (!el) return;
        const bsModal = Modal.getOrCreateInstance(el, { backdrop: "static", keyboard: false });
        const onHidden = () => setActivateDDPIModal(false);
        el.addEventListener("hidden.bs.modal", onHidden);
        bsModal.show();
        return () => {
            el.removeEventListener("hidden.bs.modal", onHidden);
            if (el.isConnected) {
                bsModal.hide();
            }
        };
    }, [activateDDPIModal]);


    useEffect(() => {
        if (proceed === true) {
            const countdown = setInterval(() => {
                if (seconds > 0) {
                    setSeconds(seconds - 1);
                } else {
                    clearInterval(countdown);
                }
            }, 1000);

            return () => {
                clearInterval(countdown);
            };
        } else {
            setSeconds(30);
        }
    }, [seconds, proceed]);

    const dematHoldings = mfData?.demat_holdings ?? props.data?.demat_holdings ?? null;

    const canUseDemat = PROFILE_DATA?.demat === true;
    const canUsePhysical = PROFILE_DATA?.physical === true;

    const bankOptions =
        redeemMode === "D" && Array.isArray(dematHoldings?.banks) && dematHoldings.banks.length > 0
            ? dematHoldings.banks
            : props.data?.banks ?? [];

    useEffect(() => {
        setMfData(props.data);
        const resolvedHoldingType = props.holdingType ?? props.data?.holding_type;
        const holdingDemat = resolvedHoldingType === "Demat";
        const nextMode = holdingDemat ? "D" : "P";
        const dh = props.data?.demat_holdings;
        const banks =
            nextMode === "D" && Array.isArray(dh?.banks) && dh.banks.length > 0
                ? dh.banks
                : props.data.banks ?? [];
        const default_bank_index = banks.findIndex((bank) => bank.is_default === true);
        if (default_bank_index !== -1) {
            setSelectedBank(banks[default_bank_index]);
        } else if (banks.length > 0) {
            setSelectedBank(banks[0]);
        }

        setTax(props.data.tax);
        setFolioData(props.data.folios || []);
        setRedeemMode(nextMode);

        if (nextMode === "D" && dh?.free_qty != null) {
            const cap = parseFloat(dh.free_qty);
            setAvailableUnits(cap.toFixed(4));
            setWithDrawUnits(cap.toFixed(4));
            setWithdrawAmount(Math.floor(cap * props.data.mf_data.nav.current_nav));
            setDisplayFolioText("");
            setSelectedFolio([]);
        } else if (props.data.folios && props.data.folios.length !== 0) {
            setSelectedFolio([props.data.folios[0]]);
            setAvailableUnits(parseFloat(props.data.folios[0].units).toFixed(4));
            setDisplayFolioText(props.data.folios[0].folio_no);
            setWithDrawUnits(parseFloat(props.data.folios[0].units).toFixed(4));
            setWithdrawAmount(
                Math.floor(props.data.folios[0].units * props.data.mf_data.nav.current_nav)
            );
        }
    }, [props.data, props.holdingType]);

    useEffect(() => {
        if (redeemMode !== "D") return;
        const free = dematHoldings?.free_qty;
        if (free == null || free === "") return;
        const cap = parseFloat(free);
        if (!withdrawAll) {
            setAvailableUnits(cap.toFixed(4));
            setWithDrawUnits((u) => {
                const n = parseFloat(u);
                if (Number.isFinite(n) && n > cap) return cap.toFixed(4);
                return u;
            });
        }
    }, [redeemMode, dematHoldings?.free_qty, withdrawAll]);

    useEffect(() => {
        if (withdrawAll === true) {
            setLongTermCapitalGain(props.data.total_long_term);
            setShortTermCapitalGain(props.data.total_short_term);
            return;
        }
        if (redeemMode === "D") {
            setLongTermCapitalGain(props.data.total_long_term);
            setShortTermCapitalGain(props.data.total_short_term);
            return;
        }
        if (selectedFolio.length !== 0) {
            setLongTermCapitalGain(selectedFolio[0].total_long_term);
            setShortTermCapitalGain(selectedFolio[0].total_short_term);
        }
    }, [withdrawAll, selectedFolio, redeemMode, props.data]);

    useEffect(() => {
        if (withdrawAll !== true) return;
        setWithdrawUnitsError("");
        // setWithdrawAmountError("");
        if (redeemMode === "D" && dematHoldings?.free_qty != null) {
            const cap = parseFloat(dematHoldings.free_qty);
            setWithDrawUnits(cap.toFixed(4));
            setSelectedFolio([]);
            setDisplayFolioText("");
            setAvailableUnits(cap.toFixed(4));
            setWithdrawAmount(Math.floor(cap * props.data.mf_data.nav.current_nav));
            return;
        }
        setWithDrawUnits(parseFloat(props.data.units).toFixed(4));
        setSelectedFolio([]);
        setDisplayFolioText("");
        setAvailableUnits(parseFloat(props.data.units).toFixed(4));
        setWithdrawAmount(Math.floor(props.data.current_amount));
    }, [withdrawAll, redeemMode, dematHoldings?.free_qty]);

    // custom hook called when clicked outside the popup to close the pop up
    useClickOutside(dropDownRef, () => {
        setShowFolioDropDown(false);
    });

    const _handleShowFolio = () => {
        if (redeemMode === "D" || withdrawAll) return;
        setShowFolioDropDown(!showFolioDropDown);
    }


    const _redeemDataPayload = (mode, folioRow) => {
        const unitsSource = folioRow
            ? folioRow.units
            : mode === "D"
                ? dematHoldings?.current_qty ?? props.data.units
                : props.data.units;
        const body = {
            id: props.data.mf_data.id,
            folio: folioRow?.folio_no ?? null,
            units: unitsSource,
            generate_today: true,
            sip_date: date,
            transaction_type: 3,
            frequency: "MONTHLY",
            mode,
        };
        return JSON.stringify(body);
    };

    const _fetchRedeemData = (mode, folioRow) => {
        const url = "mf/redeem-data";
        APIService(true, url, _redeemDataPayload(mode, folioRow)).then((response) => {
            if (response.status_code === 200) {
                setMfData(response.data);
                const nextDh = response.data?.demat_holdings;
                if (mode === "D" && Array.isArray(nextDh?.banks) && nextDh.banks.length > 0) {
                    const def = nextDh.banks.find((b) => b.is_default === true) || nextDh.banks[0];
                    setSelectedBank(def);
                }
            } else {
                toast.dismiss();
                toast.error(response.message, { type: "error" });
            }
        });
    };

    const _handleRedeemMode = (mode) => {
        if (mode === redeemMode) return;
        if (mode === "D" && !canUseDemat) return;
        if (mode === "P" && !canUsePhysical) return;
        setRedeemMode(mode);
        setWithdrawUnitsError("");
        setWithdrawAmountError("");
        setFolioError("");
        setWithdrawAll(false);
        if (mode === "D") {
            _fetchRedeemData("D", null);
            setSelectedFolio([]);
            setDisplayFolioText("");
        } else if (props.data.folios?.length) {
            const first = props.data.folios[0];
            setSelectedFolio([first]);
            setDisplayFolioText(first.folio_no);
            _fetchRedeemData("P", first);
        } else {
            _fetchRedeemData("P", null);
        }
    };

    // handler for checkbox items
    const _handleFolio = (item) => {
        setFolioError("");
        let selected_folio = [...selectedFolio];
        let selected_folie_index = selectedFolio.findIndex((f) => f.folio_no === item.folio_no);
        if (selected_folie_index == -1) {
            selected_folio.push(item);
        } else {
            selected_folio = selectedFolio.filter((f) => f.folio_no !== item.folio_no);
            selected_folio.push(item);
        }

        setSelectedFolio([...selected_folio]);
        setAvailableUnits(parseFloat(item.units).toFixed(4));
        setDisplayFolioText(item.folio_no);
        setShowFolioDropDown(false);
        setWithDrawUnits(parseFloat(item.units).toFixed(4));
        setWithdrawAmount(Math.floor(item.units * props.data.mf_data.nav.current_nav));
        _fetchRedeemData("P", item);
        // removing units to withdraw field error
        if (item.units !== '') {
            setWithdrawUnitsError('');
            setWithdrawAmountError('');
        }
    }

    // Callback function to process the units
    const _handleUnitsInput = (value) => {
        setWithDrawUnits(value);
        setWithdrawUnitsError("");
        setWithdrawAmountError("");
        let available_units =
            redeemMode === "D" && dematHoldings?.free_qty != null
                ? parseFloat(dematHoldings.free_qty)
                : selectedFolio.length !== 0
                    ? selectedFolio[0].units
                    : props.data.units;
        if (value > available_units) {

            // toast.dismiss();
            // toast.error(`Entered unit cannot be greater than ${available_units} units`,{
            //     type: 'error'
            // });
            // return;
        }
        if (value == '') {
            setWithdrawAmount('');
        } else {
            setWithdrawAmount(Math.floor(value * props.data.mf_data.nav.current_nav));
        }
    }

    const _handleAmountInput = (value) => {
        setWithdrawAmount(value);
        setWithdrawAmountError('');
        let available_units =
            redeemMode === "D" && dematHoldings?.free_qty != null
                ? parseFloat(dematHoldings.free_qty)
                : selectedFolio.length !== 0
                    ? selectedFolio[0].units
                    : props.data.units;
        if (withdrawUnits > available_units) {

            // toast.dismiss();
            // toast.error(`Entered unit cannot be greater than ${available_units} units`,{
            //     type: 'error'
            // });
            // return;
        }
        if (value == '') {
            setWithDrawUnits('');
        } else {
            setWithDrawUnits((value / props.data.mf_data.nav.current_nav).toFixed(4));
        }
    }

    const _handleWithdrawAll = () => {
        setWithdrawAll(!withdrawAll);

    }

    const _handleShowBank = () => {
        setShowBank(!showBank);
    }

    const _handleSelectedBank = (data) => {
        setSelectedBank(data);
    }

    const _handlePin = (value) => {
        setPinString(value);
        setPinError("");
    }

    const _handleGoback = () => {
        setPinString("");
        setPinError("");
        setProceed(false);
    }

    // navigate to landing
    function _navigateToLanding(path) {
        window.open(path, "_blank", "noreferrer");
    }

    const _handleBackFromDDPIOverlay = () => {
        setActivateDDPIModal(false);
    };

    const _handleActivateDDPI = () => {
        setActivateDDPIModal(false);
    };

    // validate pin
    const _validatePin = () => {
        let valid = true;
        if (pinString.length === 0) {
            setPinError("OTP Required");
            valid = false;
        }
        if (valid === true) {
            _confirmRedeem();
        }
    };

    const _validateProceed = () => {
        const unitsNum = parseFloat(withdrawUnits);
        const available_units =
            redeemMode === "D" &&
                (dematHoldings?.max_redeemable_units != null || dematHoldings?.free_qty != null)
                ? parseFloat(
                    dematHoldings?.max_redeemable_units != null
                        ? dematHoldings.max_redeemable_units
                        : dematHoldings.free_qty
                )
                : selectedFolio.length !== 0
                    ? parseFloat(selectedFolio[0].units)
                    : parseFloat(props.data.units);
        let valid = true;

        if (withdrawUnits === '' || withdrawUnits === undefined || (!withdrawAll && (!Number.isFinite(unitsNum) || unitsNum <= 0))) {
            setWithdrawUnitsError("Units is required");
            valid = false;
        }
        // if (Number.isFinite(unitsNum) && unitsNum > available_units) {
        //     setWithdrawUnitsError(
        //         `Entered units cannot exceed ${available_units} `
        //     );
        //     valid = false;
        // }
        if (redeemMode === "P" && folioData.length > 0 && selectedFolio.length === 0 && withdrawAll === false) {
            setFolioError("Folio is required");
            valid = false;
        }
        if (redeemMode === "D") {
            if (!dematHoldings?.demat_account) {
                setWithdrawUnitsError("Demat account details are not available. Refresh or contact support.");
                valid = false;
            }
            const canRedeem = (dematHoldings?.can_redeem ?? mfData?.can_redeem);
            if (canRedeem === false) {
                props.redeemOption(dematHoldings);
                valid = false;
            }
        }
        if (!withdrawAll && withdrawAmount === '') {
            setWithdrawAmountError('Amount is required');
            valid = false;
        }
        if (!selectedBank?.bank_id) {
            toast.dismiss();
            toast.error("Please select a bank", { type: "error" });
            valid = false;
        }
        if (valid === true) {
            // if (mfData?.can_redeem === false) {
            //     setActivateDDPIModal(true);
            //     return;
            // }
            _confirmProceed();
        }
    }

    // API - confirm proceed to get otp
    function _confirmProceed() {
        setApiLoader(true);
        let url = "mf/confirm-redeem";
        const base = {
            mf_id: props.data.mf_data.id,
            amount: withdrawAll === true ? null : withdrawAmount,
            redeem_all: withdrawAll,
            bank_id: selectedBank.bank_id,
            folios: redeemMode === "P" ? selectedFolio.map((item) => item.folio_no) : [],
        };
        let payload = JSON.stringify(base);

        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                setProceed(true);
                toast.dismiss();
                toast.success("OTP sent successfully", {
                    type: "success",
                });
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error"
                });
            }
            setApiLoader(false);
        });
    }

    // API - confirm redeem (same endpoint for physical + demat)
    function _confirmRedeem() {
        setApiLoader(true);
        let url = "mf/redeem";
        let payload = JSON.stringify({
            mf_id: props.data.mf_data.id,
            amount: withdrawAll === true ? null : withdrawAmount,
            redeem_all: withdrawAll,
            bank_id: selectedBank.bank_id,
            otp: pinString,
            folios: redeemMode === "P" ? selectedFolio.map((item) => item.folio_no) : [],
        });

        APIService(true, url, payload).then((response) => {
            if (response.status_code === 200) {
                document.getElementById("close-modal").dispatchEvent(new Event("click"));
                props.redeemStatus(1);
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                });
            }
            setApiLoader(false);
        });
    }

    function _handleResendOTP() {
        _consent2FA("MF")
            .then((response) => {
                toast.dismiss();
                toast.success("An OTP has been sent to your registered phone number", {
                    type: "success",
                });
                setSeconds(30);
                setPinString("");
            }).catch((response) => {
                toast.dismiss();
                toast.error(response, {
                    type: "error"
                });
            });
    }


    const SelectBank = ({ item }) => {
        const bankName = item.name || item.bank_name || "";
        const accountLabel = item.account_number || item.account_no_masked || "";

        return (
            <div className={`d-flex justify-content-between align-items-center cursor-pointer gap-8px h-100
                ${item.bank_id === selectedBank.bank_id ?
                    `border-radius-8px border-all padding-12px-all border-primary-color`
                    :
                    `border-radius-8px border-all padding-12px-all border-bright-gray`
                }`}

                onClick={() => _handleSelectedBank(item)}>
                <div className="d-flex align-items-center">
                    {item.image ? (
                        <img src={item.image} alt={bankName}
                            width={35}
                            height={35}
                            className="border-radius-100 me-1" />
                    ) : (
                        <div className="border-radius-100 me-1 d-flex align-items-center justify-content-center bg-pale-steel-blue"
                            style={{ width: 35, height: 35 }}>
                            <Icon icon="info" size={18} />
                        </div>
                    )}
                    <div className="d-flex flex-column">
                        <div className="d-flex align-items-center">
                            <span className="color-black e-poppins-semi-bold e-font-14 line-height-14px me-1 ">
                                {bankName}
                            </span>
                            <span className="color-outer-space e-poppins-medium e-font-14 line-height-14px ">{accountLabel}</span>
                        </div>
                        {
                            item.is_default === true &&
                            <p className="color-primary-color e-poppins-medium e-font-12  line-height-12px mb-0 mt-1">Primary bank</p>
                        }
                    </div>
                </div>

                <Icon icon={selectedBank.bank_id === item.bank_id ? 'radio-selected' : 'radio-unselected'}
                    size={20} />
            </div>
        )
    }

    return (
        <div className={`modal fade ${style.e_fund_redeem}`}
            id="fund-redeem"
            tabIndex="-1"
            aria-labelledby="fund-redeem"
            aria-hidden="true"
            data-bs-backdrop="true" >
            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                <div className={`modal-content bg-modal border-radius-24px padding-20px-top ps-4 padding-32px-right pb-4 position-relative ${style.e_content} `}>
                    <span id="close-modal" data-bs-dismiss="modal" className='d-none'></span>
                    {
                        proceed === false ?
                            <Fragment>

                                <p className="color-eerie-black e-poppins-medium e-font-16 line-height-16px mb-3">Withdraw details</p>
                                <Icon icon="close"
                                    size={24}
                                    data-bs-dismiss="modal"
                                    className={`position-absolute cursor-pointer e-modal-close-btn ${style.e_close}`} />

                                <div className={style.e_redeem}>
                                    <div className={style.e_body}>
                                        <div className="border-radius-16px bg-light-sky-blue pt-3 pb-4 px-4 ">
                                            <div className={`d-lg-flex d-md-flex justify-content-between gap-32px ${redeemMode !== "D" ? "border-bottom-1px border-shade-light-blue pb-3 mb-3" : ""}`}>
                                                <div className="d-flex gap-16px">
                                                    <div className="p-2 bg-white border-all border-bright-gray border-radius-4px">
                                                        <img src={props.data.mf_data.image}
                                                            alt={props.data.mf_data.name}
                                                            width={40}
                                                            height={40}
                                                            className="object-fit-contain" />
                                                    </div>
                                                    <div>
                                                        <p className="color-black e-poppins-medium e-font-14 line-height-20px mb-2">
                                                            {props.data.mf_data.name}
                                                        </p>
                                                        <p className="color-black e-poppins-black e-font-10 line-height-19px mb-0 border-all border-bright-gray py-1 padding-6px-lr border-radius-16px w-fit-content">
                                                            {props.data.mf_data.class_name}
                                                        </p>
                                                    </div>

                                                </div>

                                                <div className="">
                                                    <p className="color-black e-poppins-semi-bold e-font-14 line-height-26px mb-0 mt-lg-0 mt-md-0 mt-3">
                                                        <span className="e-inter-semi-bold">₹</span>{props.data.mf_data.nav.current_nav.toLocaleString("en-IN")} <span className=
                                                            {`e-font-10 ${props.data.mf_data.nav.nav_change < 0 ? "color-red" : "color-sea-green"}`}>
                                                            ({props.data.mf_data.nav.nav_change < 0 ? `${props.data.mf_data.nav.nav_change_percentage}` : `${props.data.mf_data.nav.nav_change_percentage}`})
                                                        </span>
                                                    </p>
                                                    <p className="color-gray e-poppins-regular e-font-10 line-height-12px mb-0 text text-lg-end text-md-end text-start">as on {props.data.mf_data.nav.nav_date}</p>
                                                </div>
                                            </div>

                                            {redeemMode !== "D" && (
                                                <div className="d-lg-flex d-md-flex gap-24px">
                                                    <p className="color-gray e-poppins-medium e-font-14 mb-lg-0 mb-md-0 mb-3">Units: <span className="color-outer-space">{props.data.units.toFixed(4)}</span></p>
                                                    <p className="color-gray e-poppins-medium e-font-14 mb-lg-0 mb-md-0 mb-3">Current: <span className="e-inter-medium color-outer-space">₹</span><span className="color-outer-space">{props.data.current_amount.toLocaleString("en-IN")}</span></p>
                                                    <p className="color-gray e-poppins-medium e-font-14 mb-0">Redemption time: <span className="color-outer-space">{props.data.redemption_time}</span></p>
                                                </div>
                                            )}

                                            {/* Hidden: specific exit load amount — general disclaimer covers scheme details
                                            <div className="d-flex mt-3">
                                                <p className="color-gray e-poppins-medium e-font-14 mb-0">Exit load: <span className="color-outer-space e-inter-medium"> ₹ {mfData.mf_data.exit_load_amount.toLocaleString('en-IN')}</span></p>
                                            </div>
                                            */}
                                        </div>

                                        {/* Holding Type */}
                                        <div className="pt-3">
                                            <div className="d-flex align-items-center gap-3 mb-3">
                                                <div onClick={canUseDemat ? () => _handleRedeemMode("D") : undefined}
                                                    className={`border-radius-8px border-all padding-12px-tb px-3
                                                       ${canUseDemat ? 'cursor-pointer' : 'cursor-not-allowed opacity-50'}
                                                       ${redeemMode === "D"
                                                            ? 'bg-pastel-green border-metallic-green'
                                                            : 'bg-flash-white border-bright-gray'}`}>
                                                    <h3 className="mb-0 color-text-black e-poppins-regular e-font-16">Demat</h3>
                                                </div>
                                                <div onClick={canUsePhysical ? () => _handleRedeemMode("P") : undefined}
                                                    className={`border-radius-8px border-all padding-12px-tb px-3
                                                         ${canUsePhysical ? 'cursor-pointer' : 'cursor-not-allowed opacity-50'}
                                                         ${redeemMode === "P"
                                                            ? 'bg-pastel-green border-metallic-green'
                                                            : 'bg-flash-white border-bright-gray'}`}>
                                                    <h3 className="mb-0 color-text-black e-poppins-regular e-font-16">Physical</h3>
                                                </div>
                                            </div>

                                            {redeemMode === "D" && dematHoldings && (
                                                <div className="border-radius-24px border-bright-gray bg-pure-white border-all p-3">
                                                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                                                        <p className="mb-0 e-poppins-medium e-font-14 line-height-16px color-gray">
                                                            Demat account:{" "}
                                                            <span className="color-text-black">{dematHoldings.demat_account}</span>
                                                            {dematHoldings.depository_type && (
                                                                <span className="ms-1 e-poppins-regular e-font-12 color-gray">
                                                                    ({dematHoldings.depository_type})
                                                                </span>
                                                            )}
                                                        </p>
                                                    </div>
                                                    <p className="color-outer-space e-poppins-regular e-font-10 line-height-14px mb-0 mt-2">
                                                        Please note that only demat-free units will be eligible for redemption. Clients are advised to ensure that sufficient units are available for redemption before placing the order.
                                                    </p>
                                                    <div className="d-flex align-items-start padding-24px-top">
                                                        <div className="flex-fill">
                                                            <p className="mb-2 mt-2 e-poppins-medium e-font-14 line-height-14px color-outer-space">Available units</p>
                                                            <h4 className="mb-2 e-poppins-semi-bold e-font-14 line-height-16px color-text-black">{dematHoldings.current_qty}</h4>
                                                        </div>
                                                        <div className="flex-fill border-start border-bright-gray ps-4">
                                                            <p className="mb-2 mt-2 e-poppins-medium e-font-14 line-height-14px color-outer-space">Free units</p>
                                                            <h4 className="mb-2 e-poppins-semi-bold e-font-14 line-height-16px color-text-black">{dematHoldings.free_qty}</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {redeemMode === "D" && !dematHoldings && (
                                                <div className="border-radius-16px bg-pale-yellow p-3 e-poppins-regular e-font-12 color-jett-black">
                                                    Demat holding details are loading or unavailable. Switch to Physical if you hold units in folio form.
                                                </div>
                                            )}

                                        </div>

                                        {/* folio dropdown — required for physical (mode P) only */}
                                        {
                                            redeemMode === "P" && folioData.length !== 0 &&
                                            <div className="position-relative margin-38px-bottom margin-26px-top">
                                                <div className="mt-1 p-2 bg-pale-yellow d-flex align-items-center border-radius-8px gap-12px mb-3">
                                                    <p className="color-jett-black e-poppins-regular e-font-12 line-height-16px mb-0">Your investments in {props.data.mf_data.name} are split into multiple folios.</p>
                                                </div>
                                                <div ref={dropDownRef}>
                                                    <div className={`py-3 padding-22px-lr cursor-pointer border-radius-12px border-all d-flex align-items-center position-relative 
                                                        ${selectedFolio.length !== 0 ? "justify-content-between" : "justify-content-end"}
                                                        ${folioError.length !== 0 ? "border-red" : "border-columbia-blue"}`}
                                                        data-disabled={withdrawAll || redeemMode === "D"}
                                                        onClick={_handleShowFolio}>
                                                        <p className={`e-poppins-regular e-font-16px line-height-16px mb-0 bg-modal z-index-1 position-absolute
                                                            ${selectedFolio.length !== 0 ? style.e_transition_top : style.e_transition_center}
                                                            ${folioError ? "color-red" : "color-black"}`}>
                                                            Select folio<span className="color-red">*</span>
                                                        </p>
                                                        {
                                                            displayFolioText.length !== 0 &&
                                                            <p className="color-black e-poppins-semi-bold e-font-16 line-height-26px mb-0">{displayFolioText}</p>
                                                        }
                                                        <div className="d-flex align-items-center">
                                                            <p className="color-gray e-poppins-medium e-font-14 mb-0">Available units: <span className="color-outer-space">{availableUnits}</span></p>
                                                            <Icon icon="calender-arrow-right"
                                                                size={24}
                                                                color={Colors.white}
                                                                className={showFolioDropDown === true ? style.e_rotate_left_90 : style.e_rotate_right_90} />
                                                        </div>
                                                    </div>
                                                    {
                                                        folioError.length !== 0 &&
                                                        <div className='position-absolute d-flex align-items-center mt-1 '>
                                                            <Icon icon="info-circle"
                                                                size={16}
                                                                className="me-1" />
                                                            <p className='color-red margin-block-end-0 e-font-12 '>
                                                                {folioError}
                                                            </p>
                                                        </div>
                                                    }
                                                    {
                                                        showFolioDropDown === true &&
                                                        <div className={`border-radius-8px border-all border-bright-gray bg-modal position-absolute w-100 z-index-1 ${style.e_folio_dropdown}`}>
                                                            {
                                                                folioData.map((item, key) => {
                                                                    let contains_all_folio = selectedFolio.some(selectedBank => selectedBank.folio_no === item.folio_no);
                                                                    return (
                                                                        <div key={key}
                                                                            className={`d-flex justify-content-between align-items-center py-3 ps-2 pe-4 ${key !== folioData.length - 1 && "border-bottom-1px border-bright-gray"} cursor-pointer`}
                                                                            onClick={() => _handleFolio(item)}>
                                                                            <div className="d-flex align-items-center gap-8px">
                                                                                <Icon icon={contains_all_folio ? "radio-selected" : "radio-unselected"}
                                                                                    size={16} />
                                                                                <p className="color-outer-space e-poppins-medium e-font-12 line-height-10px mb-0">
                                                                                    {item.folio_no}
                                                                                </p>
                                                                            </div>

                                                                            <div>
                                                                                <p className="color-outer-space e-poppins-regular e-font-12 line-height-10px mb-0">
                                                                                    Available units: <span className="color-black e-poppins-medium">{parseFloat(item.units).toFixed(4)}</span>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        <div className="row gx-0">
                                            <div className="col-lg-6 col-md-6 col-12 pe-2">
                                                <CustomRedeemTextInput label="Units to withdraw"
                                                    postfix="*"
                                                    type="number"
                                                    className="margin-38px-top"
                                                    inputClass={`e-poppins-semi-bold bg-transparent line-height-26px py-3 border-radius-12px ${style.e_redeem_input_box}`}
                                                    value={withdrawUnits}
                                                    error={withdrawUnitsError}
                                                    disabled={withdrawAll}
                                                    handleChange={_handleUnitsInput} />
                                            </div>

                                            <div className="col-lg-6 col-md-6 col-12 ps-2">
                                                <CustomRedeemInput value={withdrawAmount}
                                                    label="Approx. redeem value"
                                                    postfix="*"
                                                    className="margin-38px-top"
                                                    inputRef={amountRef}
                                                    // approxValue={withdrawUnits * props.data.mf_data.nav.current_nav}
                                                    inputClass={`e-poppins-semi-bold bg-transparent line-height-26px py-3  border-radius-12px padding-28px-left`}
                                                    error={withdrawAmountError}
                                                    disabled={withdrawAll}
                                                    allowDecimal={true}
                                                    handleChange={_handleAmountInput} />
                                            </div>
                                        </div>


                                        <div className="mt-4 d-lg-flex d-md-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center gap-8px cursor-pointer"
                                                onClick={_handleWithdrawAll}>
                                                <Icon icon={withdrawAll === true ? "checked" : "unchecked"}
                                                    size={24} />
                                                <p className="color-outer-space e-poppins-medium e-font-14 mb-0">Withdraw all units</p>
                                            </div>
                                            {/* <p className="color-gray e-poppins-medium e-font-14 mb-0 mt-lg-0 mt-md-0 mt-3">Approx. tax implication: <span className="e-inter-medium color-outer-space">₹</span><span></span><span className="color-outer-space">{tax.toLocaleString("en-IN")}</span></p> */}
                                        </div>

                                        <div className="mt-2 d-lg-flex d-md-flex  align-items-center">
                                            <p className="color-gray e-poppins-medium e-font-14 mb-0 mt-lg-0 mt-md-0 mt-3">
                                                Long term capital gain: <span className="e-inter-medium color-outer-space">₹</span><span></span><span className="color-outer-space">{longTermCapitalGain.toLocaleString("en-IN")}</span>
                                            </p>
                                            <p className="color-gray e-poppins-medium e-font-14 mb-0 mt-lg-0 mt-md-0 mt-3 ms-5">
                                                Short term capital gain: <span className="e-inter-medium color-outer-space">₹</span><span></span><span className="color-outer-space">{shortTermCapitalGain.toLocaleString("en-IN")}</span>
                                            </p>
                                        </div>
                                        <>
                                            {redeemMode === "D" && (
                                                <div className="mt-3 p-2 bg-pale-yellow border-radius-8px">
                                                    <p className="color-jett-black e-poppins-regular e-font-10 line-height-16px mb-0">
                                                        After submission, your request is tracked as a depository transfer (DTR). BSE obligation matching and pay-in file generation run on the operations side; you may see order status <strong>VALID</strong> or <strong>INVALID</strong> once the exchange feed is applied.
                                                    </p>
                                                </div>
                                            )}
                                            <div className="cursor-pointer d-flex align-items-center gap-8px justify-content-end mt-3"
                                                onClick={_handleShowBank}>
                                                <p className="color-sea-green e-poppins-medium e-font-12 mb-0">Select bank</p>
                                                <Icon icon="right-arrow"
                                                    size={24}
                                                    className={showBank === true ? style.e_rotate_left_90 : style.e_rotate_right_90} />
                                            </div>

                                            {
                                                showBank === true &&
                                                <div className="border-radius-8px border-all border-bright-gray p-2 mt-3">
                                                    <p className="color-outer-space e-poppins-regular e-font-12 mb-1">Select bank</p>
                                                    <div className="d-flex gap-8px flex-wrap">
                                                        {
                                                            bankOptions.map((item, key) =>
                                                                <div className={style.select_bank_radio} key={key}>
                                                                    <SelectBank item={item} />
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            }

                                            <div className="mt-4 p-2 bg-pale-yellow d-flex align-items-center border-radius-8px gap-12px">
                                                <Icon icon="info"
                                                    size={24} />
                                                <p className="color-jett-black e-poppins-regular e-font-10 line-height-16px mb-0">Order will be processed as per the cut-off time for each funds.</p>

                                            </div>
                                        </>
                                    </div>
                                    {
                                        <>
                                            <div className="col-12 pt-2 mb-3">
                                                <p className="color-outer-space e-poppins-regular e-font-10 mb-1">a) Lock-in & exit load will be applicable as per scheme details.</p>
                                                <p className="color-outer-space e-poppins-regular e-font-10 mb-0">b) Redemption value shown is calculated using the last NAV. Final redemption amount may vary.</p>
                                            </div>
                                            <div className="col-12 text-center  pb-2">
                                                <p className="color-outer-space e-poppins-regular e-font-10 mb-0">By continuing, I agree with the <span className="color-primary-color cursor-pointer" onClick={() => _navigateToLanding('https://www.mastertrust.co.in/disclaimer')}>Disclaimers</span> and <span className="color-primary-color cursor-pointer" onClick={() => _navigateToLanding(`${process.env.REACT_APP_LANDING_PAGE_URL}/terms`)}>T&C</span> of Mastertrust</p>
                                            </div>
                                            <div className={`w-100 h-50px d-flex align-items-center px-3 ${style.fund_avg_returns}`}>
                                                <img src={require('../../Assets/Images/portfolio/fund_avg_icon.svg').default}
                                                    className="e-filter-invert-1" />
                                                <p className="e-poppins-medium e-font-12 color-black mb-0 ms-2">
                                                    The fund has an average return of
                                                    <span className={`${props.data.mf_data.returns_1_year_int < 0 ? 'color-red' : 'color-green-crayola'}`}>
                                                        {props.data.mf_data.returns_1_year}</span> in 1 year, and the 3 year return is <span className={`${props.data.mf_data.returns_3_year_int === null ? 'color-black' : props.data.mf_data.returns_3_year_int < 0 ? 'color-red' : 'color-green-crayola'}`}>{props.data.mf_data.returns_3_year ? props.data.mf_data.returns_3_year : '-'}</span>
                                                </p>
                                            </div>
                                            <div className="mx-lg-5 mx-md-5 px-5 mt-4">
                                                <GradientButton label={"Request OTP & redeem"}
                                                    loading={apiLoader}
                                                    className="e-font-16 padding-12px-tb w-100"
                                                    handleClick={_validateProceed} />

                                            </div>
                                        </>
                                    }

                                </div>
                            </Fragment>
                            :
                            <Fragment>
                                <Icon icon="close"
                                    size={24}
                                    id="close-modal"
                                    data-bs-dismiss="modal"
                                    className={`position-absolute cursor-pointer e-modal-close-btn ${style.e_proceed_close}`} />
                                <Icon icon="arrow-right1"
                                    size={24}
                                    color={Colors.black}
                                    className={`position-absolute cursor-pointer ${style.e_back} ${apiLoader === true && "no-events"}`}
                                    onClick={_handleGoback} />
                                <div className="text-center mt-4">
                                    <img src={require("../../Assets/Images/portfolio/redeem-confirm.png")}
                                        alt="Confirm payment"
                                        width={72}
                                        height={72} />
                                    <p className="color-eerie-black e-poppins-medium e-font-18 mb-2 mt-3">Enter OTP you have received in registered email and phone number</p>

                                    {/* <p className="color-jett-black e-poppins-regular e-font-16 mb-3">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
                                    <OTPInput pinString={pinString}
                                        id="redeem-input"
                                        autoFocus={true}
                                        disabled={apiLoader}
                                        pinError={pinError}
                                        handleChange={_handlePin} />

                                </div>
                                <div className="margin-22px-top mx-5 px-5">
                                    <GradientButton label="Confirm withdrawal"
                                        className=" e-font-16 padding-12px-tb w-100"
                                        loading={apiLoader}
                                        handleClick={_validatePin} />
                                    {
                                        <div className='d-flex justify-content-center mt-4'>
                                            {
                                                seconds === 0 ?
                                                    <p className='color-primary-color e-poppins-regular e-font-14 line-height-14px cursor-pointer mb-0 e-forgot-pin position-relative w-max-content'
                                                        onClick={_handleResendOTP}>Resend OTP</p>
                                                    :
                                                    <p className='color-primary-color e-poppins-regular e-font-14 line-height-14px cursor-not-allowed mb-0 '>
                                                        Resend OTP in <span className="color-black">{seconds}s</span>
                                                    </p>
                                            }
                                        </div>
                                    }
                                </div>
                            </Fragment>
                    }

                    {activateDDPIModal === true &&
                        <ActivateDDPIModal show={activateDDPIModal}
                            onBack={_handleBackFromDDPIOverlay}
                            onActivateDDPI={_handleActivateDDPI} />
                    }
                </div>
            </div>
        </div>

    )
}

export default FundRedeemModal